export const baseURL = import.meta.env.VITE_BASE_URL;
export const authServerUrl = import.meta.env.VITE_OAUTH_URL;

export const getLoginUrl = () => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: import.meta.env.VITE_EXPENSE_CLIENT_ID,
    redirect_uri: `${window.location.origin}/callback`,
  });
  return `/auth/oauth/authorize?${params.toString()}`;
};

export const managerLevelId = 2;
export const priodSatate = [
  { periodName: 'Full Day', value: '0' },
  { periodName: 'First Half Day', value: '1' },
  { periodName: 'Second Half Day', value: '2' },
];

export const activityNames = [
  { activityName: 'Awards', activityTypeId: 13 },
  { activityName: 'Admin Work', activityTypeId: 9 },
  { activityName: 'CME', activityTypeId: 13 },
  { activityName: 'Dr.Meeting /CME/Conf.', activityTypeId: 11 },
  { activityName: 'Field Work', activityTypeId: 1 },
  { activityName: 'Meeting', activityTypeId: 3 },
  { activityName: 'Others', activityTypeId: 14 },
  { activityName: 'Stockist Activity', activityTypeId: 10 },
  { activityName: 'Training', activityTypeId: 5 },
  { activityName: 'Transit', activityTypeId: 6 },
];

let newData = JSON.parse(localStorage.getItem('userData'));
export const userInfo = {
  employeeId: newData?.employeeId,
  companyName: newData?.companyName,
  designation: newData?.designation,
  employeeName: newData?.employeeName,
  token: newData?.token,
  useName: newData?.useName,
  companyId: newData?.companyId,
  month: newData?.expenseMonth,
  year: newData?.expenseYear,
};

export const NotificationUrl =
  'https://Prodnotification.kea-sfe.com/api/notifications';
export const PublicKey =
  'BIHBWBWeS9ys7zXXteNYYpMYACQvT_eun7DFWp15DSFsNJ4OMnrGwIGZ-Yy9jJ3jsOko-CVDSPt6cw2xoB8hp0A';
